exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ui.tiny.loader.dropdown-inline-loader {\n  display: inline-block;\n  position: unset;\n  width: 32px;\n}\n.ui.tiny.loader.dropdown-inline-loader:before,\n.ui.tiny.loader.dropdown-inline-loader:after {\n  left: 32px;\n  top: 10px;\n}\n", ""]);
